import React from 'react'
import { connect } from 'react-redux';
// import { dataType } from '@/constants/data-type';
// import DataTable from '../DataTable/DataTable';
import { userActions } from '@/actions/user';
import { stockActions } from '@/actions/trading/stock.action';
import { ACTION_TYPE } from "@/constants/w-socket";
import { WS_LANG_KEY, REFRESH_DATA } from '@/constants/app';
import { utilsFunction, Converter, Comparator } from "@/helpers/functions";
import DefaultRankicon from '@/assets/images/icons/mobiles/sort_normal@2x.png';
import DownRankicon from '@/assets/images/icons/mobiles/sort_des@2x.png';
import RiseRankicon from '@/assets/images/icons/mobiles/sort_asc@2x.png';
import { LOADING_TYPE } from '@/constants/app';
import LoadingLayer from '@/components/Spinner/LoadingLayer';
import NoRow from '@/components/DataTable/CustomNoRow';
import {WATCHLIST_FILTER_TYPE} from '@/constants/filter-type'
import { PARAMS as requestParams } from '@/constants/params'; 
import { getPortfolioAction } from '@/actions/trading';
import { mobileSubLayoutAction } from '@/actions/app/mobileSubLayout.action';




class WatchlistMobile extends React.Component {
  constructor(nProps) {
    super(nProps);
    nProps.innerRef(this);
    this.state = {
      rowData:null,
      updateRowDataTime: null,
      initialData:null,
      sortType:null,
      load:false
    }
  }

  componentDidMount() {
    this.getPostion()
  }

  componentDidUpdate(preProps) {
    const { userInfo, isNeedRefresh,language ,currentTradingAccount ,marketCode} = this.props;
    // if (userInfo && preProps.userInfo !== userInfo) {
    //   this.getWatchLists()
    // }
    if (language && preProps.language !== language) {
      if(marketCode === 'position'){
          this.getPostion()
          this.props.getWatchlist({uuid: userInfo.id})
      }else if(marketCode === ''){
          this.getWatchLists()
      }else{
          this.getWatchLists(marketCode)
      }
    }

    // if (isNeedRefresh && preProps.isNeedRefresh !== isNeedRefresh) {
    //   this.getWatchLists()
    // }
    if(marketCode != preProps.marketCode){
      this.setState({sortType:null})
    }
    if (currentTradingAccount && preProps.currentTradingAccount !== currentTradingAccount) {
        this.getPostion()
    }
  }


  getPostion = (callback) => {
    this.setState({rowData:null,load:true})
    const { user, currentTradingAccount, language , mdsToken} = this.props
    const { clientID,tradingAccSeq } = currentTradingAccount
    const params = {
      [requestParams.CLIENT_ID]: clientID,
      [requestParams.TRADING_ACCOUNT_ID]: clientID,
      [requestParams.LANGUAGE]: language.lang,
      [requestParams.TRADING_ACC_SEQ]: tradingAccSeq
    }
    const dateNow = Date.now()
  this.setState({dateNow: dateNow})
    this.props.getAccountPortfolio(params, res => {
      if(dateNow != this.state.dateNow) return
      if (Array.isArray(res.portfoliosList) && res.portfoliosList.length) {
        const lang = this.props.language.lang
        const sample = ['symbol', 'stockName', 'price', 'change'].reduce((prev, next) => (prev[next] = '-', prev), {})
        const filted = res.portfoliosList
        const rowData = []
        for (let i = 0; i <  filted.length; i++) {
          const item = filted[i]
          const deepSample = JSON.parse(JSON.stringify(sample))
          deepSample.symbol = [item.marketID, item.stockCode].join('.')
          if (lang === 'zh_TW' || lang === 'zh_CN') {
            deepSample.stockName = item.stockChineseShortName
            if(!item.stockChineseShortName){
              deepSample.stockName = item.stockName
            }
          } else {
            deepSample.stockName = item.stockName
          }
          let stockID = item.stockCode.split('').findIndex(i => i !== '0')
          if (stockID > -1) stockID = item.stockCode.substr(stockID)
          const marketID = Converter.mappingWebSocketMarket(item.marketID)
          // const dparams = { instrumentID: item.stockCode, exchangeID: item.marketID }
          if (marketID === 'XNYS') {
            const params = { symbols: [{ exchangeID: marketID, key: stockID }] }
            stockActions.getStatisticsAction(params, statisticsRes => {
              if(dateNow != this.state.dateNow) return
              const twoNewRowData = JSON.parse(JSON.stringify(this.state.rowData))
              const deepSample = twoNewRowData?.[i]
              if (deepSample) {
                deepSample.price = statisticsRes.last || "-"
                stockActions.getClosingPriceAction(params, closingPriceRes => {
                  if(dateNow != this.state.dateNow) return
                  const threeNewRowData = JSON.parse(JSON.stringify(this.state.rowData))
                  const deepSample = threeNewRowData?.[i]
                  if (deepSample) {
                    deepSample.change = `${utilsFunction.datatableCurrencyFormatter(statisticsRes.last - closingPriceRes.closingPrice)} (${utilsFunction.datatableFormatPercent((statisticsRes.last - closingPriceRes.closingPrice) / closingPriceRes.closingPrice * 100)})`
                    requestAnimationFrame(() =>this.setState({ rowData: threeNewRowData }))
                  }
                })
                requestAnimationFrame(() =>this.setState({ rowData: twoNewRowData }))
              }
            })
          } else {
            const dparams = { instrumentID: item.stockCode, exchangeID: item.marketID }
            const params = {
              msgType: ACTION_TYPE.SECURITY_FINANCIAL_DATA,
              symbol: { exchangeID: marketID, key: stockID },
              language: utilsFunction.switchToolTipsLanguage(this.props.language, WS_LANG_KEY.EN, WS_LANG_KEY.SC, WS_LANG_KEY.TC)
            }
            this.props.getFinancial(params, financialres => {
              if(dateNow != this.state.dateNow) return
              if (financialres && Object.keys(financialres).length ) {
              // Object.assign(deepSample, {shares: financialres.totalCapital })
                const oneNewRowData = JSON.parse(JSON.stringify(this.state.rowData))
                if(!oneNewRowData) return
                const deepSample = oneNewRowData[i]
                if(deepSample){
                  this.props.getDetailPriceInfo(dparams, quetores => {
                    if(dateNow != this.state.dateNow) return
                    if (quetores && Object.keys(quetores).length) {
                      const twoNewRowData = JSON.parse(JSON.stringify(this.state.rowData))
                      if(!twoNewRowData) return
                      const deepSample = twoNewRowData[i]
                      deepSample.price = quetores.last
                      deepSample.change = `${utilsFunction.datatableCurrencyFormatter(quetores.last - quetores.prev)} (${utilsFunction.datatableFormatPercent((quetores.last - quetores.prev) / quetores.prev * 100)})`
                      deepSample.colorStyle = this.bindingColor(quetores.last - quetores.prev)
                      this.setState({ rowData: twoNewRowData ,initialData :JSON.parse(JSON.stringify(twoNewRowData))})
                    }
                  })
                  this.setState({ rowData: oneNewRowData,initialData :JSON.parse(JSON.stringify(oneNewRowData)) })
                }
              }
            })
          }
          rowData.push(deepSample)
        }
        this.setState({ rowData , initialData:JSON.parse(JSON.stringify(rowData)),load:false})
      }else{
        this.setState({rowData: [],  load:false})
      }
      typeof callback === 'function' && callback()
    })
  }



  getWatchLists(market = 'ALL') {
  this.setState({ rowData: [] , load:true})
  const { id } = this.props.userInfo
  const dateNow = Date.now()
  this.setState({dateNow: dateNow})
  if (id) {
    this.props.getWatchlist({ uuid: id }, res => {
      if(dateNow != this.state.dateNow) return
      if (Array.isArray(res.result) && res.result.length) {
        const lang = this.props.language.lang
        let filted = res.result.filter(item => item.name == WATCHLIST_FILTER_TYPE.All)[0].flaggings
        const sample = ['symbol', 'stockName', 'price', 'change' ,'market'].reduce((prev, next) => (prev[next] = '-', prev), {})
        const filtedData = res.result
        if (market === 'HKEX') {
          filted = res.result.filter((item)=>  item.name == WATCHLIST_FILTER_TYPE.HK)[0].flaggings
        } else if(market === 'USEX'){
          filted  = res.result.filter((item)=>  item.name == WATCHLIST_FILTER_TYPE.US)[0].flaggings
        } else if(market === 'CN'){
          filted  = res.result.filter((item)=>  item.name == WATCHLIST_FILTER_TYPE.StockConnect)[0].flaggings
        } else if(market === 'FUND'){
          filted  = res.result.filter((item)=>  item.name == WATCHLIST_FILTER_TYPE.FUND)[0].flaggings
        }else {
          filtedData.map((item)=>{
            market === item.name? filted = item.flaggings :''
          })
        }
        filted.sort((a,b)=>{ return b.weight - a.weight })
        const rowData = []
        
        const updateRowDataTime = Date.now()
        this.setState({ updateRowDataTime })
        const handleSetState = (func) => (this.state.updateRowDataTime === updateRowDataTime && func())

        for (let i = 0; i < filted.length; i++) {
          const item = filted[i]

          const deepSample = JSON.parse(JSON.stringify(sample))
          deepSample.stockName = item.name
          
          deepSample.symbol = [item.market, item.id].join('.')
          deepSample.market = item.market
          let stockID = item.id.split('').findIndex(i => i !== '0')
          if (stockID > -1) stockID = item.id.substr(stockID)
          const marketID = Converter.mappingWebSocketMarket(item.market)
          if (marketID === 'XNYS') {
            const params = { symbols: [{ exchangeID: marketID, key: stockID }] }
            stockActions.getStatisticsAction(params, statisticsRes => {
              if(dateNow != this.state.dateNow) return
              const twoNewRowData = JSON.parse(JSON.stringify(this.state.rowData))
              const deepSample = twoNewRowData?.[i]
              if (deepSample) {
                deepSample.price = statisticsRes.last || '-'
                stockActions.getClosingPriceAction(params, closingPriceRes => {
                  const threeNewRowData = JSON.parse(JSON.stringify(this.state.rowData))
                  const deepSample = threeNewRowData?.[i]
                  if (deepSample) {
                    deepSample.change = `${utilsFunction.datatableCurrencyFormatter(statisticsRes.last - closingPriceRes.closingPrice)} (${utilsFunction.datatableFormatPercent((statisticsRes.last - closingPriceRes.closingPrice) / closingPriceRes.closingPrice * 100)})`
                    this.setState({ rowData: threeNewRowData })
                  }
                })
                this.setState({ rowData: twoNewRowData ,load:false})
              }
            })
          } else{
            const dparams = { instrumentID: item.id, exchangeID: item.market }
          const params = {
            msgType: ACTION_TYPE.SECURITY_FINANCIAL_DATA,
            symbol: { exchangeID: marketID, key: stockID },
            language: utilsFunction.switchToolTipsLanguage(this.props.language, WS_LANG_KEY.EN, WS_LANG_KEY.SC, WS_LANG_KEY.TC)
          }

          this.props.getFinancial(params, financialres => {
            if(dateNow != this.state.dateNow) return
            if (financialres) {
              const oneNewRowData = JSON.parse(JSON.stringify(this.state.rowData))
              const deepSample = oneNewRowData[i]

              Object.assign(deepSample, { shares: financialres.totalCapital, lyr: financialres.earnps, marketv: financialres.marketCap })
              this.props.getDetailPriceInfo(dparams, quetores => {
                if(dateNow != this.state.dateNow) return
                if (quetores) {
                  const twoNewRowData = JSON.parse(JSON.stringify(this.state.rowData))
                  const deepSample = twoNewRowData[i]
                  deepSample.price = quetores.last || '-'
                  deepSample.change = `${utilsFunction.datatableCurrencyFormatter(quetores.last - quetores.prev)} (${utilsFunction.datatableFormatPercent((quetores.last - quetores.prev) / quetores.prev * 100)})`
                  deepSample.colorStyle = this.bindingColor(quetores.last - quetores.prev)
                  handleSetState(() => this.setState({ rowData: twoNewRowData ,initialData :JSON.parse(JSON.stringify(twoNewRowData)) }))
                }
              })
              handleSetState(() => this.setState({ rowData: oneNewRowData,initialData :JSON.parse(JSON.stringify(oneNewRowData))  }))
            }
          })
        }
        rowData.push(deepSample)
        }  
        this.setState({ rowData , initialData:JSON.parse(JSON.stringify(rowData)),load:false})
      }else{
        this.setState({load:false})
      }
    })
  }else{
    this.setState({rowData:null,load:false})
  }
  }

  bindingColor=(value)=> {
    const v = value + ""
    if(v?.indexOf('(') != -1){
      if(Number(v?.split('(')[0].replace(/,/g,"")) > 0){
        return 'rise-color'
      }else if(Number(v?.split('(')[0].replace(/,/g,"")) < 0){
        return 'fall-color'
      } else {
        return ''
      }
    }else{
      if(v?.indexOf('%')!= -1){
        if(Number(v?.split('%')[0]) > 0){
          return 'rise-color'
        }else if(Number(v?.split('%')[0]) < 0){
          return 'fall-color'
        } else {
          return ''
        }
      }
    }
    if (value > 0) {
      return 'rise-color'
    } else if (value < 0) {
      return 'fall-color'
    } else {
      return ''
    }
  }

  filterWatchlist=(market = 'ALL')=>{
    this.setState({sortType:null})
    const filted = this.state.initialData?.filter(item => market === 'ALL' || market === item.market)
    this.setState({rowData : JSON.stringify(filted) != '[]' ? filted : null})
  }

  componentWillUnmount() {
    this.setState = () => {}
  }

  sortWathlist=(sortState)=>{
    const { sortType , rowData , initialData} = this.state
    if(!rowData || JSON.stringify(rowData) == '[]') return
      if(sortType !==`${sortState}Rise` && sortType !==`${sortState}Down`){
        this.setState({sortType:`${sortState}Rise`},()=>{
          for ( let i=0;i<rowData.length-1;i++){
              for (let j=0;j<rowData.length-1-i;j++) {
                    if(Number(rowData[j][sortState] && Number(rowData[j + 1][sortState]))){
                      if(Number(rowData[j][sortState]) >  Number(rowData[j + 1][sortState])){
                        let temp = rowData[j];
                        rowData[j] = rowData[j + 1];
                        rowData[j + 1] = temp;
                      }
                    }else{
                      if(rowData[j][sortState] >  rowData[j + 1][sortState]){
                        let temp = rowData[j];
                        rowData[j] = rowData[j + 1];
                        rowData[j + 1] = temp;
                      }
                    }
              }
          } 
          this.setState({rowData})
        })
      }else if(sortType === `${sortState}Rise`){
        this.setState({sortType:`${sortState}Down`},()=>{
          for ( let i=0;i<rowData.length-1;i++){
            for (let j=0;j<rowData.length-1-i;j++) {
              if(Number(rowData[j][sortState] && Number(rowData[j + 1][sortState]))){
                if(Number(rowData[j][sortState]) <  Number(rowData[j + 1][sortState])){
                  let temp = rowData[j];
                  rowData[j] = rowData[j + 1];
                  rowData[j + 1] = temp;
                }
              }else{
                if(rowData[j][sortState] <  rowData[j + 1][sortState]){
                  let temp = rowData[j];
                  rowData[j] = rowData[j + 1];
                  rowData[j + 1] = temp;
                }
              }
            }
          } 
          this.setState({rowData},()=>{
          })
        })
      }else  if(sortType === `${sortState}Down`){
        this.setState({rowData : JSON.parse(JSON.stringify(initialData)),sortType:null})
      }
  }

  handleOpenDetailCenter = (item) => {
    if(item.symbol.indexOf('FUND') !== -1) return
    const params = {
      stockCode:item.symbol.split('.')[1],
      marketID:item.symbol.split('.')[0],
    }
    this.props.setStock(params,()=>{
      mobileSubLayoutAction.openDetailCenter(item.stockName,item.symbol)
    })
  }

  render() {
    const { rowData, columnDefs , sortType , load} = this.state;
    const { autoSize , language , marketCode , tabsWidth} = this.props
    return (
      <div className='watchlists-list'>
        <div className='rank-header'>
            <div onClick={()=>this.sortWathlist('symbol')}>{language.common_symbol}<img src={sortType === 'symbolRise' ? RiseRankicon :  sortType === 'symbolDown' ? DownRankicon : DefaultRankicon}/> </div>
            <div onClick={()=>this.sortWathlist('price')} style={{textAlign:'end'}}>{language.common_price}<img src={sortType === 'priceRise' ? RiseRankicon :  sortType === 'priceDown' ? DownRankicon : DefaultRankicon}/></div>
            <div onClick={()=>this.sortWathlist('change')} style={{textAlign:'end'}}>{language.common_change_mobile}<img src={sortType === 'changeRise' ? RiseRankicon :  sortType === 'changeDown' ? DownRankicon : DefaultRankicon}/></div>
        </div>
        <LoadingLayer load={load} type={LOADING_TYPE.BIG_IMG} />
        {rowData && JSON.stringify(rowData) !== '[]' ? rowData?.map(item =>{
          return <div key={item.symbol} className='list-item'  onClick={()=>{this.handleOpenDetailCenter(item)}}>
              <div>
                  <span style={{fontSize:'14px'}}>{item.stockName}</span>
                  <span style={{fontSize:'12px'}}>{item.symbol}</span>
              </div>
              <div className={item.colorStyle} style={{textAlign:'end'}}><span>{item.price}</span></div>
              <div className={item.colorStyle} style={{textAlign:'end'}}><span>{item.change}</span></div>
          </div>
        })
        : !load && <NoRow style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '93%' , width :'100%'}} />
      }

      </div>
    )
  }

}

WatchlistMobile.defaultProps = {
  isFilter: false,
  autoSize: true
}

export default connect(
  state => ({
    language: state.app.language,
    currentTradingAccount: state.trade.currentTradingAccount,
    marketParams: state.trade.marketParams,
    userInfo: state.user.userInfo,
    isNeedRefresh: state.refresh.marketAction,
    user: state.auth.user,
    mdsToken: state.trade.mdsToken
  }),
  dispatch => ({
    getWatchlist: (p, c) => dispatch(userActions.getInstrumentWatchlistAction(p, c)),
    getDetailPriceInfo: (p, c) => stockActions.enquireInstrumentInfoAction(p, c),
    getFinancial: (p, c) => stockActions.getFinancialAction(p, c),
    setStock: (p, res) => dispatch(stockActions.setMarketStockAction(p, res)),
    getAccountPortfolio: (p, c) => dispatch(getPortfolioAction(p, c)),
    toggleRefreshMarket: (p) => dispatch({
      type: REFRESH_DATA.MARKET_ACTION,
      value: p
    })
  })
)(WatchlistMobile)
